export const GET_SELLER_SUCCESS = "GET_SELLER_SUCCESS";
export const GET_SELLER_ERROR = "GET_SELLER_ERROR";

export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const UPDATE_QUANTITY_IN_CART = "UPDATE_QUANTITY_IN_CART";
export const CLEAR_CART = "CLEAR_CART";
